/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Domain_Status_FailingInputs */



/**
* | output |
* | --- |
* | "Not being served — the domain has stopped proving ownership." |
*
* @param {Canvas_Domain_Status_FailingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_domain_status_failing = /** @type {((inputs?: Canvas_Domain_Status_FailingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Domain_Status_FailingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird nicht ausgeliefert – die Domain weist den Besitz nicht mehr nach.")
	return /** @type {LocalizedString} */ ("Not being served — the domain has stopped proving ownership.")
});